import seven from "../assets/svg/projects/seven.svg";
import blog from "../assets/svg/projects/blog.svg";
import team from "../assets/svg/projects/team.svg";
import pharmacy from "../assets/svg/projects/pharmacy.svg";
import job from "../assets/svg/projects/job.svg";
import eCommerce from "../assets/svg/projects/eCommerce.svg";
import threads from "../assets/svg/projects/threads.jpg";

export const projectsData = [
  {
    id: 1,
    projectName: "Threads & Beads",
    projectDesc:
      "online handmade crafts and jewelry marketplace with an Angular-based frontend and a Node.js-based backend",
    tags: ["NodeJs", "Angular", "MongoDB", "Bootstrap"],
    code: "https://github.com/orgs/ThreadsAndBeads/repositories",
    demo: "https://threadsandbeads-4863e.web.app/",
    image: threads,
  },
  {
    id: 2,
    projectName: "Pharmacies System (DrugRadar)",
    projectDesc:
      "pharmacy system that simplifies the process of ordering and delivering medication (dashboard and mobile API)",
    tags: ["Laravel", "MYSQL", "JavaScript", "Bootstrap"],
    code: "https://github.com/DrugRadar/Pharmacy-Proj",
    demo: "https://www.youtube.com/watch?v=q13ReHRv8VM",
    image: pharmacy,
  },
  {
    id: 3,
    projectName: "Articles-Dashboard (Authorlytics)",
    projectDesc:
      "This PHP-based articles website is designed to manage users ,groups and articles,\n and assign roles to each user based on their group",
    tags: ["PHP", "MYSQL", "JavaScript", "Bootstrap"],
    code: "https://github.com/Authorlytics-Dashboard/Articles-Dashboard",
    demo: "https://www.youtube.com/watch?v=4-UdTVfevS0",
    image: seven,
  },
  {
    id: 4,
    projectName: "posts-blog",
    projectDesc: "This is a simple blog posts project built with Laravel",
    tags: ["Laravel", "MYSQL", "JavaScript", "Bootstrap"],
    code: "https://github.com/hagerk720/posts-blog-laravel",
    demo: "",
    image: blog,
  },
  {
    id: 5,
    projectName: "Team-up-app",
    projectDesc:
      "Team collaboration platform for facilitating participation in work",
    tags: ["Java", "Android", "Firebase Database", "Firebase Cloud Messaging"],
    code: "https://github.com/hagerk720/Team-up-app",
    demo: "",
    image: team,
  },
  {
    id: 6,
    projectName: "jobs-app",
    projectDesc:
      "Jobs is a flutter application for users to view all jobs published on it\n and users can apply to any job they like by uploading their CV file",
    tags: ["Flutter", "Dart"],
    code: "https://github.com/hagerk720/jobs-app",
    demo: "",
    image: job,
  },
  {
    id: 7,
    projectName: "E-Commerce (RHM)",
    projectDesc:
      " Furniture E-Commerce project built with vanilla JS and attractive animated UI",
    tags: ["JavaScript", "CSS", "HTML", "Bootstrap"],
    code: "https://github.com/RHM-team/RHM-E-Commerce",
    demo: "https://www.youtube.com/watch?v=dmpEiHEEMuI",
    image: eCommerce,
  },
];
